import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import qs from "qs";
import uuidv1 from "uuid";
import {
  localizedPushHistory,
  pushHistory,
} from "../../../../core/modules/common/tools/HistoryTools";
import ReportDefinitions from "../../../common/config/ReportDefinitions";
import { errorNotification } from "../../../common/redux/actions/CapeNotificationActions";
import Routes from "../../../common/routes/Routes";
import SelectionCriteriaHeader from "../components/SelectionCriteriaHeader";
import {
  getSelectedValues,
  getSelectionCriteria,
  getWizardValidationErrors,
} from "../redux/selectors/SelectionCriteriaWizardSelectors";
import {
  enteredWizard,
  createRequestId,
} from "../redux/actions/SelectionCriteriaWizardActions";
import { wizardRoutes } from "../Routes/WizardRoutes";
import SelectionCriteriaDto from "../../../report/common/models/SelectionCriteriaDto";
import {
  changeAsync,
  reportClearData,
  reportLoadData,
  updateReportCustomFilter,
} from "../../../report/common/redux/actions/ReportsActions";
import {
  currentUserReportActionCreator,
  currentSavedUserReportActionCreator,
  fetchUserReportDefinitionsRequestActionCreator,
  reportLastScSetsRequestActionCreator,
  userLoaded,
} from "../../../user/redux/actions/UserActions";
import {
  getCurrentReport,
  getUserReports,
  getCurrentSavedUserReportId,
  getScSets,
  getUserLoaded,
} from "../../../user/redux/selectors/UserReportSelectors";
// import { dateFieldSelected, dayPeriodSelected, weekPeriodSelected, monthPeriodSelected } from '../../period-selector/redux/actions/PeriodSelectionActions';
import { carrierCheckedActionCreator } from "../../target-node-carrier-selector/redux/actions/CarrierActions";
import { handlerCheckedActionCreator } from "../../target-node-handler-selector/redux/actions/HandlerActions";
import { arrivalMailProcessingCenterCheckedActionCreator } from "../../target-node-impc-selector/redux/actions/ArrivalPostalOperatorActions";
import { departureMailProcessingCenterCheckedActionCreator } from "../../target-node-impc-selector/redux/actions/DeparturePostalOperatorActions";
import { setDirectionFlag as impcSetDirectionFlag } from "../../target-node-impc-selector/redux/actions/PostalOperatorActions";
import { arrivalMailboxCheckedActionCreator } from "../../target-node-mailbox-selector/redux/actions/ArrivalPostalOperatorActions";
import { departureMailboxCheckedActionCreator } from "../../target-node-mailbox-selector/redux/actions/DeparturePostalOperatorActions";
import { setDirectionFlag as mailboxSetDirectionFlag } from "../../target-node-mailbox-selector/redux/actions/PostalOperatorActions";
import { arrivalMailProcessingCenterCheckedActionCreator as arrivalMrdCheckedActionCreator } from "../../target-node-mrd-impc-selector/redux/actions/ArrivalPostalOperatorActions";
import { departureMailProcessingCenterCheckedActionCreator as departureMrdCheckedActionCreator } from "../../target-node-mrd-impc-selector/redux/actions/DeparturePostalOperatorActions";
import { arrivalUnlocodeCheckedActionCreator } from "../../target-node-unlocode-selector/redux/actions/ArrivalPostalOperatorActions";
import { departureUnlocodeCheckedActionCreator } from "../../target-node-unlocode-selector/redux/actions/DeparturePostalOperatorActions";
import { setDirectionFlag as unlocodeSetDirectionFlag } from "../../target-node-unlocode-selector/redux/actions/PostalOperatorActions";
import { transportModeSelected } from "../../transport-mode-selector/redux/actions/TransportModeActions";
import { mailClassSelected } from "../../product-selector/redux/actions/ProductActions";
import PRODUCT_TYPES from "../../../common/redux/actions/types/ProductTypes";
import Modal from "../../../../core/modules/common/components/Modal";
import { getOpenEmailModal } from "../../../report/common/redux/selectors/ReportsSelectors";
import Button from "../../../../core/modules/common/components/Button";

export class SelectionCriteriaWizardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lastSelectionsLoaded: false,
      userLoaded: false,
      openEmailWarningModal: false,
    };
  }

  UNSAFE_componentWillMount() {
    const {
      params: { reportName },
    } = this.props.match;
    const { pathname } = this.props.location;
    const lastPath = pathname.slice(pathname.lastIndexOf("/") + 1);
    if (!ReportDefinitions[reportName]) {
      this.props.errorNotification(`Report ${reportName} does not exist`);
      localizedPushHistory(Routes.REPORT_DEFINITIONS);
    } else {
      // eslint-disable-next-line no-lonely-if
      if (
        lastPath !== "report" &&
        Object.keys(this.props.getScSets).length === 0
      ) {
        this.props.enteredWizard(reportName);
      }
    }
  }

  componentDidMount() {
    if (this.props.userReports.length === 0) {
      this.props.fetchUserReportDefinitionsRequestActionCreator();
    }

    if (Object.keys(this.props.getScSets).length === 0) {
      this.props.currentUserReportActionCreator(
        this.props.match.params.reportName
      );
    }

    const reportId = this.props.match.params.reportName;
    const reportDefinition = ReportDefinitions[reportId];
    // Use scSetApiKey if defined, otherwise generate from items
    let hyphenSeperatedScSet = reportDefinition.selectionCriteria.scSetApiKey;
    if (!hyphenSeperatedScSet) {
      // eslint-disable-next-line no-nested-ternary
      const productSuffix = reportDefinition.productTypes === PRODUCT_TYPES.MAIL_SUBCLASS
        ? ""
        : reportDefinition.productTypes === PRODUCT_TYPES.MAIL_CLASS
        ? "L"
        : "C";
      hyphenSeperatedScSet = reportDefinition.selectionCriteria.items
        .map((s) => s.replace(/^SC+/, ""))
        .map((s) => s.replace(/^0+/, ""))
        .map((s) => s.replace(/^30+/, `30${productSuffix}`))
        .join("_");
    }
    const hyphenSeperatedDirectionSet =
      reportDefinition.reportDirections.join("_");
    if (Object.keys(this.props.getScSets).length === 0) {
      this.props.reportLastScSetsRequestActionCreator(
        hyphenSeperatedScSet,
        hyphenSeperatedDirectionSet
      );
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(previousProperties, previousState) {
    const { currentReport } = this.props;

    if (
      currentReport &&
      currentReport.reportCode !== this.props.match.params.reportName
    ) {
      this.props.currentUserReportActionCreator(
        this.props.match.params.reportName
      );
    }

    if (
      this.props.openEmailModal !== undefined &&
      this.props.openEmailModal &&
      previousProperties.openEmailModal !== this.props.openEmailModal
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        openEmailWarningModal: true,
      });
    }
    const queryParams = qs.parse(
      (this.props.location.search || "").replace("?", "")
    );
    let sc;

    if (!this.state.userLoaded) {
      if (queryParams.id && !this.props.getUserLoaded) {
        if (this.props.currentReportSavedId === queryParams.id) return;
        this.props.currentSavedUserReportActionCreator(queryParams.id);

        sc = queryParams.recent
          ? currentReport.recent
          : (currentReport.saved || []).find(
              (item) => item.id.toString() === queryParams.id
            );

        if (!sc) return;

        const reportDefinition = ReportDefinitions[currentReport.reportCode];

        if (sc.direction) {
          const defaultDirection = reportDefinition.reportDirections[0];
          if (sc.direction !== defaultDirection) {
            const flag = { switched: true };
            this.props.impcSetDirectionFlag(flag);
            this.props.mailboxSetDirectionFlag(flag);
            this.props.unlocodeSetDirectionFlag(flag);
          }
        }

        if (sc.carriers && sc.carriers.length) {
          this.props.carrierCheckedActionCreator(sc.carriers);
        }
        if (sc.handlers && sc.handlers.length) {
          this.props.handlerCheckedActionCreator(sc.handlers);
        }
        if (sc.originExchangeOffices && sc.originExchangeOffices.length) {
          this.props.departureMailProcessingCenterCheckedActionCreator(
            sc.originExchangeOffices,
            reportDefinition
          );
          this.props.departureMrdCheckedActionCreator(
            sc.originExchangeOffices,
            reportDefinition
          );
        }
        if (
          sc.destinationExchangeOffices &&
          sc.destinationExchangeOffices.length
        ) {
          this.props.arrivalMailProcessingCenterCheckedActionCreator(
            sc.destinationExchangeOffices,
            reportDefinition
          );
          this.props.arrivalMrdCheckedActionCreator(
            sc.destinationExchangeOffices,
            reportDefinition
          );
        }
        if (sc.originMailboxes && sc.originMailboxes.length) {
          this.props.departureMailboxCheckedActionCreator(
            sc.originMailboxes,
            reportDefinition
          );
        }
        if (sc.destinationMailboxes && sc.destinationMailboxes.length) {
          this.props.arrivalMailboxCheckedActionCreator(
            sc.destinationMailboxes,
            reportDefinition
          );
        }
        if (sc.originUnlocodes && sc.originUnlocodes.length) {
          this.props.departureUnlocodeCheckedActionCreator(
            sc.originUnlocodes,
            reportDefinition
          );
        }
        if (sc.destinationUnlocodes && sc.destinationUnlocodes.length) {
          this.props.arrivalUnlocodeCheckedActionCreator(
            sc.destinationUnlocodes,
            reportDefinition
          );
        }
        if (sc.legsWithTransportModes && sc.legsWithTransportModes.length) {
          sc.legsWithTransportModes.forEach((tm) =>
            this.props.transportModeSelected(tm.legCode, tm.transportModes)
          );
        }
        if (
          sc.mailCategoriesWithSubClasses &&
          sc.mailCategoriesWithSubClasses.length
        ) {
          sc.mailCategoriesWithSubClasses.forEach((product) =>
            this.props.mailClassSelected(
              product.mailCategoryCode,
              product.mailSubClasses
            )
          );
        }
        if (sc.destinationOperatorCodes && sc.destinationOperatorCodes.length) {
          this.props.arrivalMailProcessingCenterCheckedActionCreator(
            sc.destinationOperatorCodes,
            reportDefinition
          );
          this.props.arrivalMrdCheckedActionCreator(
            sc.destinationOperatorCodes,
            reportDefinition
          );
        }
        if (sc.originOperatorCodes && sc.originOperatorCodes.length) {
          this.props.departureMailProcessingCenterCheckedActionCreator(
            sc.originOperatorCodes,
            reportDefinition
          );
          this.props.departureMrdCheckedActionCreator(
            sc.originOperatorCodes,
            reportDefinition
          );
        }
        const customFilter = {};
        if ("allOrigin" in sc) customFilter.allOrigin = sc.allOrigin;
        if ("allDestination" in sc)
          customFilter.allDestination = sc.allDestination;
        if ("showSending" in sc) customFilter.showSending = sc.showSending;
        if ("showReceiving" in sc)
          customFilter.showReceiving = sc.showReceiving;
        if ("showMailBoxes" in sc)
          customFilter.showMailBoxes = sc.showMailBoxes;
        if ("mrdLikeStatus" in sc)
          customFilter.mrdLikeStatus = sc.mrdLikeStatus;
        if ("excludeEtoes" in sc) customFilter.excludeEtoes = sc.excludeEtoes;
        if (Object.keys(customFilter).length)
          this.props.updateReportCustomFilter(customFilter);

        // CWW-1408 Selection period of saved report is disabled
        // if (sc.dateField) {
        //   this.props.dateFieldSelected(sc.dateField);
        // }
        // if (sc.period && sc.period.from && sc.period.to) {
        //   const period = {
        //     startDate: new Date(sc.period.from),
        //     endDate: new Date(sc.period.to),
        //   };
        //   this.props.dayPeriodSelected(period);
        //   this.props.weekPeriodSelected(period);
        //   this.props.monthPeriodSelected(period);
        // }
      } else if (!this.state.lastSelectionsLoaded) {
        sc = this.props.getScSets.scSets || this.props.getScSets;
        if (!sc || !sc.scSet) return;
        if (!currentReport) return;

        const reportDefinition = ReportDefinitions[currentReport.reportCode];

        if (sc.direction && this.props.selectionCriteria.direction) {
          this.props.selectionCriteria.direction = sc.direction;
        }

        if (sc.carriers && sc.carriers.length) {
          this.props.carrierCheckedActionCreator(sc.carriers);
        }
        if (sc.handlers && sc.handlers.length) {
          this.props.handlerCheckedActionCreator(sc.handlers);
        }
        if (sc.originExchangeOffices && sc.originExchangeOffices.length) {
          this.props.departureMailProcessingCenterCheckedActionCreator(
            sc.originExchangeOffices,
            reportDefinition
          );
          this.props.departureMrdCheckedActionCreator(
            sc.originExchangeOffices,
            reportDefinition
          );
        }
        if (
          sc.destinationExchangeOffices &&
          sc.destinationExchangeOffices.length
        ) {
          this.props.arrivalMailProcessingCenterCheckedActionCreator(
            sc.destinationExchangeOffices,
            reportDefinition
          );
          this.props.arrivalMrdCheckedActionCreator(
            sc.destinationExchangeOffices,
            reportDefinition
          );
        }
        if (sc.originMailboxes && sc.originMailboxes.length) {
          this.props.departureMailboxCheckedActionCreator(
            sc.originMailboxes,
            reportDefinition
          );
        }
        if (sc.destinationMailboxes && sc.destinationMailboxes.length) {
          this.props.arrivalMailboxCheckedActionCreator(
            sc.destinationMailboxes,
            reportDefinition
          );
        }
        if (sc.originUnlocodes && sc.originUnlocodes.length) {
          this.props.departureUnlocodeCheckedActionCreator(
            sc.originUnlocodes,
            reportDefinition
          );
        }
        if (sc.destinationUnlocodes && sc.destinationUnlocodes.length) {
          this.props.arrivalUnlocodeCheckedActionCreator(
            sc.destinationUnlocodes,
            reportDefinition
          );
        }
        if (sc.legsWithTransportModes && sc.legsWithTransportModes.length) {
          sc.legsWithTransportModes.forEach((tm) =>
            this.props.transportModeSelected(tm.legCode, tm.transportModes)
          );
        }
        if (
          sc.mailCategoriesWithSubClasses &&
          sc.mailCategoriesWithSubClasses.length
        ) {
          sc.mailCategoriesWithSubClasses.forEach((product) =>
            this.props.mailClassSelected(
              product.mailCategoryCode,
              product.mailSubClasses
            )
          );
        }
        if (sc.destinationOperatorCodes && sc.destinationOperatorCodes.length) {
          this.props.arrivalMailProcessingCenterCheckedActionCreator(
            sc.destinationOperatorCodes,
            reportDefinition
          );
          this.props.arrivalMrdCheckedActionCreator(
            sc.destinationOperatorCodes,
            reportDefinition
          );
        }
        if (sc.originOperatorCodes && sc.originOperatorCodes.length) {
          this.props.departureMailProcessingCenterCheckedActionCreator(
            sc.originOperatorCodes,
            reportDefinition
          );
          this.props.departureMrdCheckedActionCreator(
            sc.originOperatorCodes,
            reportDefinition
          );
        }
        const customFilter = {};
        if ("allOrigin" in sc) customFilter.allOrigin = sc.allOrigin;
        if ("allDestination" in sc)
          customFilter.allDestination = sc.allDestination;
        if ("showSending" in sc) customFilter.showSending = sc.showSending;
        if ("showReceiving" in sc)
          customFilter.showReceiving = sc.showReceiving;
        if ("showMailBoxes" in sc)
          customFilter.showMailBoxes = sc.showMailBoxes;
        if ("mrdLikeStatus" in sc)
          customFilter.mrdLikeStatus = sc.mrdLikeStatus;
        if ("excludeEtoes" in sc) customFilter.excludeEtoes = sc.excludeEtoes;
        if (Object.keys(customFilter).length) {
          this.props.updateReportCustomFilter(customFilter);
        }

        this.state.lastSelectionsLoaded = true;
      }
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        userLoaded: true,
      });
      this.props.userLoaded(true);
    }
  }

  createGenerateReportHandler = () => {
    const {
      params: { reportName },
    } = this.props.match;
    const { mainReportId } = this.props.reporting[reportName];
    const reportId = mainReportId || reportName;
    let id = null;
    if (this.props.reporting[reportId].mainReportId !== null) {
      id = this.props.reporting[reportId].mainReportId;
    } else {
      id = reportId;
    }
    const report = ReportDefinitions[id];
    const { requestParams } = this.props.reporting[id];

    const selectionCriteria = new SelectionCriteriaDto(
      this.props.selectionCriteria,
      report.selectionCriteria.items
    );
    const newRequestParams = { ...requestParams };
    const newSelectionCriteria = { ...selectionCriteria };
    const createReqId = uuidv1();
    this.props.createRequestId(createReqId);

    newRequestParams.reportCode = reportId;
    newRequestParams.requestId = createReqId;

    newSelectionCriteria.reportCode = reportId;
    newSelectionCriteria.requestId = createReqId;
    selectionCriteria.reportCode = reportId;
    selectionCriteria.requestId = createReqId;

    if (
      JSON.stringify(newRequestParams) !== JSON.stringify(newSelectionCriteria)
    ) {
      this.props.reportClearData();
      this.props.reportLoadData(report, null, selectionCriteria);
    }
    const route = `${this.props.match.url}/report`;
    pushHistory(route);
  };

  createEmailReportHandler = () => {
    const {
      params: { reportName },
    } = this.props.match;
    const { mainReportId } = this.props.reporting[reportName];
    const reportId = mainReportId || reportName;
    let id = null;
    if (this.props.reporting[reportId].mainReportId !== null) {
      id = this.props.reporting[reportId].mainReportId;
    } else {
      id = reportId;
    }
    const report = ReportDefinitions[id];
    const { requestParams } = this.props.reporting[id];

    const selectionCriteria = new SelectionCriteriaDto(
      this.props.selectionCriteria,
      report.selectionCriteria.items
    );
    selectionCriteria.requestMode = "ASYNC";
    const newRequestParams = { ...requestParams };
    const newSelectionCriteria = { ...selectionCriteria };

    const createReqId = uuidv1();
    newRequestParams.reportCode = reportId;
    newRequestParams.requestId = createReqId;

    newSelectionCriteria.reportCode = reportId;
    newSelectionCriteria.requestId = createReqId;
    selectionCriteria.reportCode = reportId;
    selectionCriteria.requestId = createReqId;
    if (
      JSON.stringify(newRequestParams) !== JSON.stringify(newSelectionCriteria)
    ) {
      this.props.reportClearData();
      this.props.reportLoadData(report, null, selectionCriteria);
    }
    this.changeMode(reportName);
    const route = `${this.props.match.url}/report`;
    pushHistory(route);
  };

  changeMode = (reportName) => {
    this.props.changeAsync({
      reportDefinition: {
        id: ReportDefinitions[reportName].id,
      },
      isAsyncRequest: true,
    });
  };

  closeWarning = () => {
    this.setState({
      openEmailWarningModal: false,
    });
  };

  render() {
    if (!this.props.currentReport) return <div />;
    const {
      params: { reportName },
    } = this.props.match;
    const { mainReportId } = this.props.reporting[reportName] || {};
    const reportId = mainReportId || reportName;
    const routes = wizardRoutes(reportId);
    const report = ReportDefinitions[reportId];
    const { requestParams } = this.props.reporting[reportId] || {};
    const pathPartials = this.props.location.pathname.split("/");
    const isReportPage = pathPartials[pathPartials.length - 1] === "report";
    const selectionCriteria = this.props.selectionCriteria
      ? new SelectionCriteriaDto(
          this.props.selectionCriteria,
          report.selectionCriteria.items
        )
      : {};
    const newRequestParams = { ...requestParams };
    const newSelectionCriteria = { ...selectionCriteria };
    newRequestParams.reportCode = null;
    newSelectionCriteria.reportCode = null;
    const canFetchReport =
      JSON.stringify(newRequestParams) !== JSON.stringify(newSelectionCriteria);
    return (
      <div>
        <h2 className="report-title">
          {this.props.currentReport.topLevelName}
        </h2>
        <SelectionCriteriaHeader
          report={report}
          routes={routes}
          selectedValues={this.props.selectedValues}
          canGenerateReport={this.props.validationErrors.length === 0}
          canFetchReport={canFetchReport}
          isReportPage={isReportPage}
          clearSelectedDateType={this.props.clearSelectedDateType}
          onGenerateClick={this.createGenerateReportHandler}
          emailClick={this.createEmailReportHandler}
        />
        {this.state.openEmailWarningModal && (
          <Modal onClose={this.closeWarning} className="email-warning-modal">
            <div>
              Your report request has been successfully submitted. The link to
              download the report will be sent to you at your registered e-mail
              address when the report is ready.
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "10px",
              }}
            >
              <Button text="app.button.close" onClick={this.closeWarning} />
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedValues: getSelectedValues(state),
    selectionCriteria: getSelectionCriteria(state),
    validationErrors: getWizardValidationErrors(state),
    currentReport: getCurrentReport(state),
    userReports: getUserReports(state),
    currentReportSavedId: getCurrentSavedUserReportId(state),
    reporting: state.reporting,
    getScSets: getScSets(state),
    openEmailModal: getOpenEmailModal(state),
    getUserLoaded: getUserLoaded(state),
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      errorNotification,
      reportClearData,
      reportLoadData,
      enteredWizard,
      currentUserReportActionCreator,
      currentSavedUserReportActionCreator,
      fetchUserReportDefinitionsRequestActionCreator,
      carrierCheckedActionCreator,
      handlerCheckedActionCreator,
      arrivalMailProcessingCenterCheckedActionCreator,
      departureMailProcessingCenterCheckedActionCreator,
      arrivalMailboxCheckedActionCreator,
      departureMailboxCheckedActionCreator,
      arrivalMrdCheckedActionCreator,
      departureMrdCheckedActionCreator,
      arrivalUnlocodeCheckedActionCreator,
      departureUnlocodeCheckedActionCreator,
      transportModeSelected,
      mailClassSelected,
      updateReportCustomFilter,
      // dateFieldSelected,
      // dayPeriodSelected,
      // weekPeriodSelected,
      // monthPeriodSelected,
      impcSetDirectionFlag,
      mailboxSetDirectionFlag,
      unlocodeSetDirectionFlag,
      reportLastScSetsRequestActionCreator,
      changeAsync,
      createRequestId,
      userLoaded,
    },
    dispatch
  );

export const ConnectedSelectionCriteriaWizardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectionCriteriaWizardContainer);

export default ConnectedSelectionCriteriaWizardContainer;

SelectionCriteriaWizardContainer.propTypes = {
  location: PropTypes.objectOf(PropTypes.shape),
  errorNotification: PropTypes.func,
  match: PropTypes.shape({
    params: PropTypes.shape({
      reportName: PropTypes.string.isRequired,
    }),
  }),
  reportClearData: PropTypes.func,
  clearSelectedDateType: PropTypes.func,
  reportLoadData: PropTypes.func,
  selectedValues: PropTypes.objectOf(PropTypes.shape),
  validationErrors: PropTypes.arrayOf(PropTypes.shape),
  selectionCriteria: PropTypes.objectOf(PropTypes.shape),
  reporting: PropTypes.objectOf(PropTypes.shape),
  createRequestId: PropTypes.func,
  currentUserReportActionCreator: PropTypes.func,
  currentSavedUserReportActionCreator: PropTypes.func,
  fetchUserReportDefinitionsRequestActionCreator: PropTypes.func,
  userReports: PropTypes.arrayOf(PropTypes.object),
  currentReport: PropTypes.objectOf(PropTypes.shape),
  currentReportSavedId: PropTypes.string,
  carrierCheckedActionCreator: PropTypes.func,
  handlerCheckedActionCreator: PropTypes.func,
  arrivalMailProcessingCenterCheckedActionCreator: PropTypes.func,
  departureMailProcessingCenterCheckedActionCreator: PropTypes.func,
  arrivalMailboxCheckedActionCreator: PropTypes.func,
  departureMailboxCheckedActionCreator: PropTypes.func,
  arrivalMrdCheckedActionCreator: PropTypes.func,
  departureMrdCheckedActionCreator: PropTypes.func,
  arrivalUnlocodeCheckedActionCreator: PropTypes.func,
  departureUnlocodeCheckedActionCreator: PropTypes.func,
  transportModeSelected: PropTypes.func,
  mailClassSelected: PropTypes.func,
  updateReportCustomFilter: PropTypes.func,
  // dateFieldSelected: PropTypes.func,
  // dayPeriodSelected: PropTypes.func,
  // weekPeriodSelected: PropTypes.func,
  // monthPeriodSelected: PropTypes.func,
  impcSetDirectionFlag: PropTypes.func,
  mailboxSetDirectionFlag: PropTypes.func,
  unlocodeSetDirectionFlag: PropTypes.func,
  reportLastScSetsRequestActionCreator: PropTypes.func,
  getScSets: PropTypes.objectOf(PropTypes.shape),
  changeAsync: PropTypes.func,
  userLoaded: PropTypes.func,
  openEmailModal: PropTypes.bool,
};
